import {KeycloakService} from 'keycloak-angular';
import {environment as env} from '../environments/environment';

export function initializeKeycloak(keycloak: KeycloakService): () => Promise<boolean> {
  return () => {
    if (!window.location.pathname.startsWith('/public')) {
      return keycloak.init({
        config: {
          url: env.keycloak.issuer,
          realm: env.keycloak.realm,
          clientId: env.keycloak.clientId,
        },
        initOptions: {
          onLoad: 'login-required',
          checkLoginIframe: false,
        },
      });
    } else {
      return Promise.resolve(true);
    }
  };
}
